<div class="textRecordsContainer">
  <!-- <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <span class="sr-only">Loading...</span> -->
  <div class="loader" *ngIf="bodySpinner"></div>
  <!-- <div class="header hdr">
         <div class="row" id="emailTableSearch">
                <div class="col-3">
        <h5><span class="animateH5">AI RFP Training</span></h5>
        </div>
        <div class="col px-0">
       </div>
    </div>
    </div> -->
  <div class="container-fluid px-0">
    <div id="contractwrapper">
      <div class="d-flex">
        <div class="left-panel" *ngIf="!botExpand">
          <!-- Add New Category button ABOVE search — Admin only -->
          <!-- @if(currentUserDetail?.role == "Admin"){
    <div *ngIf="!botEnabled"
      class="tool-header"
      (click)="OpenModal('category','new', null)">
      <label>Add New Category</label>
      <button class="btn new-btn">
        <span>+</span>
      </button>
    </div>
  } -->

          <div class="doc-list-wrapper">
            <!-- Search -->
            <div class="position-relative px-1 py-1">
              <span class="search-wrapper">
                <span class="icon">
                  <i class="fa-solid fa-magnifying-glass"></i>
                </span>
                <input
                  type="text"
                  [(ngModel)]="listSearch"
                  autocomplete="off"
                  placeholder="search company"
                  class="form-control audioTableSearchInput"
                  name="searchInput"
                  id="searchInput"
                />
                <span class="icon" (click)="listSearch = ''">
                  <i *ngIf="listSearch" class="fa-solid fa-xmark"></i>
                </span>
              </span>
            </div>

            <!-- Company / Category list -->
            <ul class="list-items-v">
              <ng-container *ngIf="companyListData.length > 0">
                @if (
                  companyListData | filter: listSearch : "company_name";
                  as result
                ) {
                  @if (result.length > 0) {
                    @for (items of result; track items.id) {
                      <li class="accordion" *ngIf="items?.is_active">
                        <!-- Parent header row -->
                        <div
                          class="header"
                          [ngClass]="{
                            expand: selectedParentRfpId == items?.id,
                          }"
                        >
                          <!-- Chevron toggle — only if has children -->
                          <span
                            class="icons"
                            *ngIf="items?.child?.length > 0"
                            (click)="selectCompany(items)"
                          >
                            <span class="icon de-active">
                              <i class="bi bi-chevron-down"></i>
                            </span>
                            <span class="icon active">
                              <i class="bi bi-chevron-up"></i>
                            </span>
                          </span>

                          <!-- Spacer when no children so title stays aligned -->
                          <span
                            *ngIf="!items?.child?.length"
                            style="
                              min-width: 20px;
                              display: inline-block;
                              flex-shrink: 0;
                            "
                          >
                          </span>

                          <!-- Company name -->
                          <span class="title" (click)="selectCompany(items)">
                            {{ items?.company_name }}
                          </span>

                          <!-- Admin action icons -->
                          @if (currentUserDetail?.role == "Admin") {
                            <span
                              class="action-icons"
                              (click)="$event.stopPropagation()"
                            >
                              <!-- <span class="icon"
                        tooltip="Edit"
                        [options]="myOptions"
                        (click)="editRFP(items)">
                        <i class="bi bi-pencil-square"></i>
                      </span> -->

                              <!-- <span class="icon"
                        tooltip="Delete"
                        [options]="myOptions"
                        (click)="deleteRFP(items?.id)">
                        <i class="bi bi-trash"></i>
                      </span> -->

                              <span
                                class="icon"
                                tooltip="Add SubFolder"
                                [options]="myOptions"
                                (click)="OpenModal('category', 'new', items)"
                              >
                                <i class="bi bi-folder-plus"></i>
                              </span>
                            </span>
                          }
                        </div>

                        <!-- Sub folders -->
                        @if (items?.child?.length > 0) {
                          <div
                            class="sub-folder"
                            [ngClass]="{
                              'is-active': selectedParentRfpId == items?.id,
                            }"
                          >
                            @for (subitems of items?.child; track subitems.id) {
                              <li
                                (click)="selectedList(items, subitems)"
                                [ngClass]="{
                                  active:
                                    selectedRfp == subitems?.id &&
                                    selectedParentRfpId == items?.id,
                                }"
                              >
                                <span class="icons">
                                  <span class="icon">
                                    <i class="bi bi-folder"></i>
                                  </span>
                                </span>

                                <span class="title">
                                  {{ subitems?.type_name }}
                                </span>

                                @if (currentUserDetail?.role == "Admin") {
                                  <span
                                    class="action-icons"
                                    (click)="$event.stopPropagation()"
                                  >
                                    <span
                                      class="icon"
                                      tooltip="Edit"
                                      [options]="myOptions"
                                      (click)="editRFP(subitems)"
                                    >
                                      <i class="bi bi-pencil-square"></i>
                                    </span>

                                    <span
                                      class="icon"
                                      tooltip="Delete"
                                      [options]="myOptions"
                                      (click)="deleteRFP(subitems?.id)"
                                    >
                                      <i class="bi bi-trash"></i>
                                    </span>
                                  </span>
                                }
                              </li>
                            }
                          </div>
                        }
                      </li>
                    }
                  } @else {
                    <p>Not found</p>
                  }
                }
              </ng-container>
            </ul>
          </div>
        </div>
        <div class="right-panel" *ngIf="!botEnabled">
          <div class="right-panel-header">
            <div class="panel-left">
              <span class="expand-icon" (click)="expandBot()">
                <i style="font-size: 1rem" class="bi bi-arrows-fullscreen"></i>
              </span>
              <label class="rfp-name"
                >{{ selectedCompanyDetails?.company_name }}
                <ng-container *ngIf="selectedRfp != null">
                  <span class="icon" *ngIf="selectedRfPDetails?.type_name"
                    ><i class="bi bi-chevron-double-right"></i
                  ></span>
                  {{ selectedRfPDetails?.type_name }}
                </ng-container>
              </label>
              @if (documentListData.length > 0) {
                <span class="ai-search" (click)="changeTobot()">
                  <img
                    src="../../../../../assets/images/ai_assist_1.png"
                    width="35"
                    height="35"
                  />
                  <label>Question Answer</label>
                </span>
              }
            </div>
            <div class="panel-right">
              <span class="search-wrapper">
                <span class="icon"
                  ><i class="fa-solid fa-magnifying-glass"></i
                ></span>
                <input
                  type="text"
                  [(ngModel)]="documentSearch"
                  autocomplete="off"
                  placeholder="Search Document"
                  class="form-control audioTableSearchInput"
                  name="searchInput"
                  id="searchInput"
                />
                <span class="icon" (click)="documentSearch = ''"
                  ><i *ngIf="documentSearch" class="fa-solid fa-xmark"></i
                ></span>
              </span>
              @if (currentUserDetail?.role == "Admin") {
                <div
                  class="btn-wrapper trans-width"
                  (click)="OpenModal('trainai')"
                >
                  <span class="icon"><i class="bi bi-cloud-arrow-up"></i></span>
                  <span class="title">Upload</span>
                </div>
              }
            </div>
          </div>
          <div class="right-panel-body">
            <div class="row">
              <div class="col-12">
                <!-- <div class="checkbox-wrapper-toggle">
                            <input class='tgl tgl-ios' id='toggle-34' type='checkbox' [checked]="selectAll" (change)="toggleSelectAll()">
                            <label class='tgl-btn' for='toggle-34'></label>
                            <span>Select All</span>
                        </div> -->
              </div>
            </div>

            <div class="position-relative">
              <div
                class="doc-container"
                appScrollNearEnd
                [threshold]="2"
                (nearEnd)="onNearEndScroll()"
              >
                <div class="doc-list-items" [ngClass]="{ loading: loading }">
                  @if (documentListData.length > 0) {
                    @for (
                      docitems of documentListData
                        | filter: documentSearch : "title";
                      track docitems.id;
                      let idx = $index
                    ) {
                      <div
                        class="cart-items"
                        [ngClass]="{
                          stripe: loading,
                          active: docitems['id'] == previewDocId,
                        }"
                      >
                        <!-- <div class="checkbox-wrapper">
                                            <input  type="checkbox" name="documents" id="{{idx}}" [checked]="isDocumentSelected(docitems)" (change)="toggleDocumentSelection(docitems)"><label  class="check-box" for="{{idx}}"></label>
                                        </div>   -->
                        <div
                          class="content"
                          (click)="previewFile(docitems)"
                          data-bs-toggle="modal"
                          data-bs-target="#docPreview"
                        >
                          <!-- <span class="doc-status-badge" [ngClass]="docitems?.is_expired ? 'badge--expired' : 'badge--active'">
                                            {{ docitems?.is_expired ? 'Expired' : 'Active' }}
                                        </span> -->
                          <span
                            tooltip="{{ docitems.title }}"
                            [options]="myOptions"
                          >
                            @switch (docitems.doc_type) {
                              @case ("docx") {
                                <img
                                  src="../../../../../assets/images/file_types/docx.png"
                                  width="100"
                                  height="auto"
                                />
                              }
                              @case ("doc") {
                                <img
                                  src="../../../../../assets/images/file_types/docx.png"
                                  width="100"
                                  height="auto"
                                />
                              }
                              @case ("pdf") {
                                <img
                                  src="../../../../../assets/images/file_types/pdf.png"
                                  width="100"
                                  height="auto"
                                />
                              }
                              @case ("xlsx") {
                                <img
                                  src="../../../../../assets/images/file_types/excel-file.png"
                                  width="100"
                                  height="auto"
                                />
                              }
                              @case ("xls") {
                                <img
                                  src="../../../../../assets/images/file_types/excel-file.png"
                                  width="100"
                                  height="auto"
                                />
                              }
                              @case ("txt") {
                                <img
                                  src="../../../../../assets/images/file_types/txt-file.png"
                                  width="100"
                                  height="auto"
                                />
                              }
                            }
                          </span>
                          <span class="file-details">
                            {{ docitems.title }}</span
                          >
                          <span class="file-details">
                            {{ docitems.created_by }}</span
                          >
                        </div>
                        <div class="footer">
                          <span class="date-label">
                            {{
                              docitems.updated_at == null
                                ? (docitems.created_at | date: "MMM d, y")
                                : (docitems.updated_at | date: "MMM d, y")
                            }}</span
                          >
                          <span class="tools">
                            <span class="icons">
                              @if (docitems?.metadata?.summary) {
                                <span
                                  class="icon"
                                  tooltip="Summary"
                                  [options]="myOptions"
                                  data-bs-target="#companyDetails"
                                  data-bs-toggle="modal"
                                  (click)="showSummary(docitems)"
                                >
                                  <i class="pi pi-file-o"></i
                                ></span>
                              }

                              <span class="icon">
                                <div class="dropdown" appToolDropdown>
                                  <div class="dropdown-trigger">
                                    <a class="is-small pad-5-10">
                                      <span class="icon">
                                        <i class="fa fa-ellipsis-v"></i
                                      ></span>
                                    </a>
                                  </div>
                                  <div class="dropdown-menu">
                                    <div class="dropdown-content">
                                      @if (currentUserDetail?.role == "Admin") {
                                        <a
                                          class="dropdown-item"
                                          (click)="EditTraine(docitems)"
                                        >
                                          <span class="icon">
                                            <i class="bi bi-cloud-arrow-up"></i
                                          ></span>
                                          Re-upload
                                        </a>
                                      }
                                      <a
                                        class="dropdown-item"
                                        (click)="downloadFile(docitems)"
                                      >
                                        <span class="icon"
                                          ><i class="bi bi-cloud-arrow-down"></i
                                        ></span>
                                        Download
                                      </a>
                                      @if (currentUserDetail?.role == "Admin") {
                                        <a
                                          class="dropdown-item"
                                          (click)="deleteDocument(docitems)"
                                        >
                                          <span class="icon">
                                            <i class="bi bi-trash"></i
                                          ></span>
                                          Delete
                                        </a>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </span>
                          </span>
                        </div>
                      </div>
                    }
                  } @else {
                    <div
                      class="d-flex align-items-center justify-content-center w-100"
                      style="height: 200px"
                    >
                      <span *ngIf="!bodySpinner"> No Records </span>
                    </div>
                  }
                </div>
              </div>
              <div
                class="paginationRecords"
                *ngIf="documentListData.length > 0"
              >
                <div class="d-flex align-items-center">
                  <span class="col-md-6 pagination-records">
                    Showing {{ documentListData.length }} of
                    {{ total_records }} records
                  </span>
                  <span class="col-md-6 pull-right">
                    <!-- <pagination-controls #pagination [maxSize]="7" [responsive]="true" [autoHide]="true"
                                    [directionLinks]="true" (pageChange)="pageChanged($event)">

                                </pagination-controls> -->
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-panel" *ngIf="botEnabled">
          <div class="position-relative w-100">
            <div class="header-tools">
              <span (click)="changeTobot()"
                ><i class="fa-solid fa-angle-left"></i> Back to documents</span
              >
              <span class="query-select">
                <div class="checkbox-wrapper-toggle">
                  <!-- <input class='tgl tgl-ios' id='toggle-33' type='checkbox' name="single" [checked]="selectAll" (change)="toggleSelectAll('single')">
                                    <label class='tgl-btn' for='toggle-33'></label> -->
                  <span class="label-text"
                    ><b>{{ selectedCompanyDetails?.company_name }}</b>
                    <ng-container *ngIf="selectedRfp != null">
                      <span class="icon" *ngIf="selectedRfPDetails?.type_name"
                        ><i class="bi bi-chevron-double-right"></i
                      ></span>
                      <b>{{ selectedRfPDetails?.type_name }}</b></ng-container
                    >
                  </span>
                </div>
                <!-- <ng-container *ngFor="let types of queryTypes">
                     <div class="check-list"  (change)="selectQueryType(types?.type)">
                       <label><input type="radio" name="native" value="{{types?.type}}" [checked]="types?.type==queryType" />{{types?.label}}</label>
                     </div>
                    </ng-container>  -->
              </span>
              <span>
                <ul class="query-tabs">
                  <li
                    (click)="showTools('history')"
                    [ngClass]="{ active: tabContent == 'history' }"
                  >
                    <span class="icon" tooltip="History" [options]="myOptions"
                      ><i class="bi bi-clock"></i
                    ></span>
                  </li>
                  <li
                    (click)="showTools('pin')"
                    [ngClass]="{ active: tabContent == 'pin' }"
                  >
                    <span class="icon" tooltip="Pin" [options]="myOptions"
                      ><i class="bi bi-pin"></i
                    ></span>
                  </li>
                  <li
                    (click)="showTools('files')"
                    [ngClass]="{ active: tabContent == 'files' }"
                  >
                    <span class="icon" tooltip="File" [options]="myOptions">
                      <i class="bi bi-file-earmark-text"></i
                    ></span>
                  </li>
                  <li
                    (click)="showTools('audio')"
                    [ngClass]="{ active: tabContent == 'audio' }"
                  >
                    <span class="icon" tooltip="Audio" [options]="myOptions">
                      <i class="bi bi-file-earmark-music"></i
                    ></span>
                  </li>
                </ul>
              </span>
            </div>
            <div class="tools-data-list" *ngIf="showToolspopUp">
              <div class="tools-header">
                <span class="title">
                  <ng-container *ngIf="tabContent == 'history'">
                    <h4>History</h4>
                  </ng-container>
                  <ng-container *ngIf="tabContent == 'pin'">
                    <h4>Pin</h4>
                  </ng-container>
                  <ng-container *ngIf="tabContent == 'files'">
                    <h4>Document</h4>
                  </ng-container>
                  <ng-container *ngIf="tabContent == 'audio'">
                    <h4>Audio</h4>
                  </ng-container>
                </span>
                <span class="icons">
                  <span class="icon" (click)="showTools('')">
                    <i class="bi bi-x-lg"></i>
                  </span>
                </span>
              </div>
              <div class="tools-content-body">
                <div class="left-content">
                  <loaders-inline *ngIf="loader" [type]="1"></loaders-inline>
                  <ng-container *ngIf="tabContent == 'pin'">
                    <ng-container *ngIf="botQAPinnedList.length > 0">
                      @if (selectedPinRecord) {
                        <bot-question-answer
                          [clientId]="client_id"
                          [section]="'contract'"
                          *ngIf="!loader"
                          [data]="selectedPinRecord"
                        ></bot-question-answer>
                      }
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="tabContent == 'files'">
                    <pdf-viewer
                      *ngIf="!loader"
                      [src]="urlSafe"
                      [render-text]="true"
                      [original-size]="false"
                      style="width: 100%; height: 100vh"
                    ></pdf-viewer>
                  </ng-container>
                  <ng-container *ngIf="tabContent == 'audio'">
                    <div class="d-flex justify-content-center">
                      <ng-container *ngIf="!loader">
                        <audio
                          *ngIf="urlSafe"
                          [src]="urlSafe"
                          controls
                          controlsList="nodownload"
                        ></audio>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
                <div class="right-content">
                  <ng-container *ngIf="tabContent == 'history'">
                    <div class="">
                      <div class="search-wrapper">
                        <span class="icon"
                          ><i class="fa-solid fa-magnifying-glass"></i
                        ></span>
                        <input
                          type="text"
                          [(ngModel)]="historySearch"
                          autocomplete="off"
                          placeholder="Search"
                          class="form-control audioTableSearchInput"
                          name="searchInput"
                          id="searchInput"
                        />
                        <span class="icon" (click)="historySearch = ''"
                          ><i
                            *ngIf="historySearch"
                            class="fa-solid fa-xmark"
                          ></i
                        ></span>
                      </div>
                      <ul>
                        <ng-container *ngIf="botQAList.length > 0">
                          @if (
                            botQAList | filter: historySearch : "question";
                            as result
                          ) {
                            @if (result.length > 0) {
                              @for (item of result; track item.id) {
                                <li>
                                  <span
                                    class="label"
                                    (click)="gotoBotQA(item?.qid)"
                                  >
                                    {{ item.question }}
                                  </span>
                                  <span class="icons">
                                    <span
                                      class="icon"
                                      (click)="deleteQuery(item)"
                                      ><i class="bi bi-trash"></i
                                    ></span>
                                  </span>
                                </li>
                              }
                            } @else {
                              <p>Not found</p>
                            }
                          }
                        </ng-container>

                        <ng-container *ngIf="botQAList.length == 0">
                          <p style="text-align: center">No Records</p>
                        </ng-container>
                      </ul>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="tabContent == 'pin'">
                    <div class="">
                      <div class="search-wrapper">
                        <span class="icon"
                          ><i class="fa-solid fa-magnifying-glass"></i
                        ></span>
                        <input
                          type="text"
                          [(ngModel)]="historySearch"
                          autocomplete="off"
                          placeholder="Search"
                          class="form-control audioTableSearchInput"
                          name="searchInput"
                          id="searchInput"
                        />
                        <span class="icon" (click)="historySearch = ''"
                          ><i
                            *ngIf="historySearch"
                            class="fa-solid fa-xmark"
                          ></i
                        ></span>
                      </div>
                      <ul
                        appScrollNearEnd
                        [threshold]="2"
                        (nearEnd)="onScrollPinned()"
                      >
                        <ng-container *ngIf="botQAPinnedList.length > 0">
                          @if (
                            botQAPinnedList
                              | filter: historySearch : "question";
                            as result
                          ) {
                            @if (result.length > 0) {
                              @for (item of result; track item.id) {
                                <li
                                  [class.active]="
                                    selectedPinRecord['qid'] == item['qid']
                                  "
                                >
                                  <span
                                    class="label"
                                    (click)="selectedPinRecord = item"
                                  >
                                    {{ item.question }}
                                  </span>
                                  <span class="icons">
                                    <span
                                      class="icon"
                                      (click)="unPinnedQuery(item)"
                                      ><i class="bi bi-trash"></i
                                    ></span>
                                  </span>
                                </li>
                              }
                            } @else {
                              <p>Not found</p>
                            }
                          }
                        </ng-container>
                        <ng-container *ngIf="botQAPinnedList.length == 0">
                          <p style="text-align: center">No Records</p>
                        </ng-container>
                      </ul>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="tabContent == 'files'">
                    <div class="">
                      <div class="search-wrapper">
                        <span class="icon"
                          ><i class="fa-solid fa-magnifying-glass"></i
                        ></span>
                        <input
                          type="text"
                          [(ngModel)]="historySearch"
                          autocomplete="off"
                          placeholder="Search"
                          class="form-control audioTableSearchInput"
                          name="searchInput"
                          id="searchInput"
                        />
                        <span class="icon" (click)="historySearch = ''"
                          ><i
                            *ngIf="historySearch"
                            class="fa-solid fa-xmark"
                          ></i
                        ></span>
                      </div>
                      <ul
                        appScrollNearEnd
                        [threshold]="2"
                        (nearEnd)="onScrollGenFiles()"
                      >
                        <ng-container *ngIf="botQAFileList.length > 0">
                          @if (
                            botQAFileList | filter: historySearch : "question";
                            as result
                          ) {
                            @if (result.length > 0) {
                              @for (
                                item of result;
                                track item.qid;
                                let index = $index
                              ) {
                                <li
                                  [class.active]="
                                    selectedPinRecord['select_index'] == index
                                  "
                                >
                                  <span class="icon"
                                    ><i
                                      *ngIf="item?.doc_type == 'docx'"
                                      class="bi bi-filetype-docx"
                                    ></i>
                                    <i
                                      *ngIf="item?.doc_type == 'pdf'"
                                      class="bi bi-filetype-pdf"
                                    ></i
                                  ></span>
                                  <span
                                    class="label"
                                    (click)="showQABotfile(item, index)"
                                  >
                                    {{ item.question }}
                                  </span>
                                  <span class="icons">
                                    <span
                                      class="icon"
                                      (click)="removeFile(item)"
                                      ><i class="bi bi-trash"></i
                                    ></span>
                                    <span
                                      class="icon"
                                      (click)="downloadfile(item)"
                                      ><i class="bi bi-download"></i
                                    ></span>
                                  </span>
                                </li>
                              }
                            } @else {
                              <p style="text-align: center">Not found</p>
                            }
                          }
                        </ng-container>
                        <ng-container *ngIf="botQAFileList.length == 0">
                          <p style="text-align: center">No Records</p>
                        </ng-container>
                      </ul>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="tabContent == 'audio'">
                    <div class="">
                      <div class="search-wrapper">
                        <span class="icon"
                          ><i class="fa-solid fa-magnifying-glass"></i
                        ></span>
                        <input
                          type="text"
                          [(ngModel)]="historySearch"
                          autocomplete="off"
                          placeholder="Search"
                          class="form-control audioTableSearchInput"
                          name="searchInput"
                          id="searchInput"
                        />
                        <span class="icon" (click)="historySearch = ''"
                          ><i
                            *ngIf="historySearch"
                            class="fa-solid fa-xmark"
                          ></i
                        ></span>
                      </div>
                      <ul
                        appScrollNearEnd
                        [threshold]="2"
                        (nearEnd)="onScrollGenFiles()"
                      >
                        <ng-container *ngIf="botQAAudioFileList.length > 0">
                          @if (
                            botQAAudioFileList
                              | filter: historySearch : "question";
                            as result
                          ) {
                            @if (result.length > 0) {
                              @for (
                                item of result;
                                track item.qid;
                                let index = $index
                              ) {
                                <li
                                  [class.active]="
                                    selectedPinRecord['select_index'] == index
                                  "
                                >
                                  <span
                                    class="label"
                                    (click)="showQABotfile(item, index)"
                                  >
                                    {{ item.question }}
                                  </span>
                                  <span class="icons">
                                    <span
                                      class="icon"
                                      (click)="removeFile(item)"
                                      ><i class="bi bi-trash"></i
                                    ></span>
                                    <span
                                      class="icon"
                                      (click)="downloadfile(item)"
                                      ><i class="bi bi-download"></i
                                    ></span>
                                  </span>
                                </li>
                              }
                            } @else {
                              <p style="text-align: center">Not found</p>
                            }
                          }
                        </ng-container>
                        <ng-container *ngIf="botQAAudioFileList.length == 0">
                          <p style="text-align: center">No Records</p>
                        </ng-container>
                      </ul>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div
              class="aibot-container"
              [ngClass]="{ 'bot-active': botEnabled }"
            >
              <span class="position-relative">
                <span class="expand-icon" (click)="expandBot()">
                  <i
                    style="font-size: 1rem"
                    class="bi bi-arrows-fullscreen"
                  ></i>
                </span>
              </span>
              <div class="aibotsection">
                <div class="botwrapper">
                  <chat-bot-query
                    [placeholderText]="'Search...'"
                    (QuestionComplete)="searchQuery($event)"
                    [allowClear]="selectedDocuments.size > 0"
                  ></chat-bot-query>
                </div>
                <div id="chat-list-content">
                  <div
                    class="bot-history-data"
                    appScrollNearEnd
                    [threshold]="2"
                    (nearEnd)="onScrollBotQuery()"
                  >
                    <span *ngIf="spinner">
                      <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i
                    ></span>
                    <ng-contaienr *ngIf="botQAList.length > 0; else noRecords">
                      @for (datalist of botQAList; track i; let i = $index) {
                        <bot-question-answer
                          [clientId]="client_id"
                          [section]="'contract'"
                          [data]="datalist"
                          [appName]="'infosec'"
                          (toolsAction)="botToolsAction($event)"
                        ></bot-question-answer>
                      }
                    </ng-contaienr>
                    <ng-template #noRecords>
                      <p *ngIf="!spinner" style="text-align: center">
                        No Records
                      </p>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="document-list-accordion" style="display: none">
                <div class="document-list">
                  <div class="position-relative">
                    <div class="header w-100">
                      <div class="checkbox-wrapper-toggle">
                        <input
                          class="tgl tgl-ios"
                          id="toggle-33"
                          type="checkbox"
                          name="single"
                          [checked]="selectAll"
                          (change)="toggleSelectAll('single')"
                        />
                        <label class="tgl-btn" for="toggle-33"></label>
                        <span class="label-text">{{
                          selectedRfPDetails?.type_name
                        }}</span>
                      </div>
                      <span
                        class="icons"
                        [class.is-active]="documentSection == 'single'"
                        (click)="selectDocSection('single')"
                      >
                        <span class="icon" *ngIf="documentSection == 'all'"
                          ><i class="bi bi-chevron-up"></i
                        ></span>
                        <span class="icon" *ngIf="documentSection == 'single'"
                          ><i class="bi bi-chevron-down"></i
                        ></span>
                      </span>
                    </div>
                    <div
                      class="documents"
                      [class.is-active]="documentSection == 'single'"
                    >
                      @if (documentListData.length > 0) {
                        <ul>
                          <ng-container
                            *ngFor="
                              let item of documentListData;
                              let idx = index;
                              let e = even
                            "
                          >
                            <li *ngIf="item?.metadata?.document_id">
                              <div class="list-check-group">
                                <input
                                  type="checkbox"
                                  name="documents"
                                  id="{{ idx }}"
                                  [checked]="isDocumentSelected(item)"
                                  (change)="toggleDocumentSelection(item)"
                                /><label class="check-box" for="{{ idx }}">
                                  <span>{{ item?.title }}</span></label
                                >
                              </div>
                            </li>
                          </ng-container>
                        </ul>
                      }
                    </div>
                  </div>
                </div>
                <div class="document-list">
                  <div class="position-relative">
                    <div class="header w-100">
                      <div class="checkbox-wrapper-toggle">
                        <input
                          class="tgl tgl-ios"
                          id="toggle-34"
                          type="checkbox"
                          name="all"
                          [checked]="selectAllDocument"
                          (change)="toggleSelectAll('all')"
                        />
                        <label class="tgl-btn" for="toggle-34"></label>
                        <span class="label-text">All Documents</span>
                      </div>
                      <span
                        class="icons"
                        [class.is-active]="documentSection == 'all'"
                        (click)="selectDocSection('all')"
                      >
                        <span class="icon" *ngIf="documentSection == 'single'"
                          ><i class="bi bi-chevron-up"></i
                        ></span>
                        <span class="icon" *ngIf="documentSection == 'all'"
                          ><i class="bi bi-chevron-down"></i
                        ></span>
                      </span>
                    </div>
                  </div>
                  <div
                    class="documents"
                    [class.is-active]="documentSection == 'all'"
                  >
                    @if (documentsAllList.length > 0) {
                      <ul>
                        <ng-container
                          *ngFor="
                            let item of documentsAllList;
                            let idx = index;
                            let e = even
                          "
                        >
                          <li *ngIf="item?.metadata?.document_id">
                            <div class="list-check-group">
                              <input
                                type="checkbox"
                                name="documents"
                                id="{{ idx }}"
                                [checked]="isDocumentSelected(item)"
                                (change)="toggleDocumentSelection(item)"
                              /><label class="check-box" for="{{ idx }}">
                                <span>{{ item?.title }}</span></label
                              >
                            </div>
                          </li>
                        </ng-container>
                      </ul>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--RFP form modal window -->
<div
  class="modal fade topicFormModal"
  data-bs-keyboard="false"
  id="rfpDetails"
  #topicModal
>
  <div class="modal-dialog modal-dialog-scrollable modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Category</h4>
        <span>
          <!-- <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp; -->
          <i
            class="fa-solid fa-xmark exitIcon"
            #closebutton
            data-bs-dismiss="modal"
            aria-label="Close"
          ></i>
        </span>
      </div>
      <div>
        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <div class="modal-body" *ngIf="!spinner">
        <div class="col">
          <form
            class="rfpconfigFrom"
            [formGroup]="rfpconfigFrom"
            autocomplete="off"
          >
            <div class="row">
              <div class="col-3">
                <label for="topic" class="form-label mandatoryLabel"
                  >Category Type
                  <i class="fa-solid fa-asterisk mandatoryIcon"></i
                ></label>
              </div>
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  formControlName="type_name"
                  id="type_name"
                  name="type_name"
                  placeholder="Enter Your Category Type"
                  autocomplete="off"
                />
                <span
                  class="text-danger"
                  *ngIf="
                    submitted && rfpconfigFrom.hasError('required', 'type_name')
                  "
                  >Category Type is required.
                </span>
                <span
                  class="text-danger"
                  *ngIf="
                    submitted &&
                    rfpconfigFrom.controls['type_name'].hasError('pattern')
                  "
                >
                  Enter valid category
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <label for="topic" class="form-label mandatoryLabel"
                  >Category Description
                  <i class="fa-solid fa-asterisk mandatoryIcon"></i
                ></label>
              </div>
              <div class="col">
                <textarea
                  class="form-control"
                  formControlName="description"
                ></textarea>
                <span
                  class="text-danger"
                  *ngIf="
                    submitted &&
                    rfpconfigFrom.hasError('required', 'description')
                  "
                  >Category description is required.
                </span>
                <span
                  class="text-danger"
                  *ngIf="
                    submitted &&
                    rfpconfigFrom.controls['description'].hasError('pattern')
                  "
                  >Enter valid description
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <label class="form-label mandatoryLabel">Active </label>
              </div>
              <div class="col">
                <div class="form-check form-switch">
                  <label class="form-check-label" for="active"></label>
                  <input
                    class="form-check-input"
                    type="checkbox"
                    formControlName="is_active"
                    name="is_active"
                    id="active"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <div class="form-group topicBtnGroup">
          <ng-container>
            <button
              class="btn btn-info cancelBtn"
              type="reset"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </button>
            <button
              *ngIf="!showUpdateButton"
              class="btn btn-primary updateBtn"
              type="button"
              (click)="saveRfp()"
            >
              Save
            </button>
            <button
              *ngIf="showUpdateButton"
              class="btn btn-primary updateBtn"
              type="button"
              (click)="updateRFP()"
            >
              Update
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!--RFP Train modal window -->
<div
  class="modal fade rfpTrainFormModal"
  data-bs-keyboard="false"
  id="rfpTrain"
  #topicModal
>
  <div class="modal-dialog modal-dialog-scrollable modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">AI Training</h4>
        <span (click)="exitIconReset()" #existModal>
          <i
            class="fa metricFullscreen"
            [ngClass]="{
              'fa-down-left-and-up-right-to-center': metricFullscreen,
              'fa-up-right-and-down-left-from-center': !metricFullscreen,
            }"
            (click)="metricFullscreen = !metricFullscreen"
          ></i
          >&nbsp;&nbsp;
          <i
            class="fa-solid fa-xmark exitIcon"
            #closebutton
            data-bs-dismiss="modal"
            aria-label="Close"
          ></i>
        </span>
      </div>
      <div>
        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <div class="modal-body" *ngIf="!spinner">
        <div class="col">
          <div class="stepper-wrapper">
            <div class="stepper-items">
              <ul></ul>
            </div>
            <div class="stepper-panels">
              <div class="step-pannel-content">
                <div class="step-pannel-body">
                  <!-- <form [formGroup]="uploadFileForm">
                    
                       <div class="d-flex justify-content-center flex-row mt-2">
                            <div class="col-2">Title <i class="fa-solid fa-asterisk mandatoryIcon"></i></div>
                            <div class="col-4">
                                <input type="text" name="title" Trimtext formControlName="title" placeholder="Enter title" />
                                <span class="text-danger"  *ngIf="submitted && uploadFileForm.hasError('required','title')">
                                  Title required
                                </span>
                                <span class="text-danger"
                    *ngIf="submitted && uploadFileForm.controls['title'].hasError('pattern')">
                    Enter valid title
                    </span>
                            </div>
                            </div> 
                        <div  class="d-flex justify-center align-center flex-column mt-3">
                            <span class="d-flex justify-content-center align-items-center">
                                @if(uploadSelectFile.length==0){
                                 <label for="customFileUpload" class="custom-upload-button">
                                    <span>Upload File</span>
                                    <input type="file"  #excelFile accept=".txt,.doc,.docx,.xls,.xlsx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" id="customFileUpload" style="display: none;" (change)="chooseUploadFile($event)">
                                </label>
                                }

                                <span>{{uploadSelectFile[0]?.name}}</span>
                                 
                                 
                            </span>
                             <div class="d-flex justify-content-center flex-row mt-2">
                            <div class="col-2"></div>
                            <div class="col-4"><span class="text-danger"
                    *ngIf="submitted && uploadSelectFile.length==0">
                    File Required
                    </span></div>
                            </div>
                          
                      
                        </div>
                     </form> -->

                  <div class="sheet-form-list" *ngIf="showsheetform">
                    <div class="sheet-form-container">
                      <form [formGroup]="excelSheetForm">
                        <div formArrayName="sheets" class="sheet-list">
                          <table class="table table-responsive">
                            <thead>
                              <th>Sheet Name</th>
                              <th>Question Column</th>
                              <th>Answer Column</th>
                              <!-- <th>Starting row</th> -->
                              <th>Comments Column</th>
                              <th>Attachments column</th>
                            </thead>
                            <tbody>
                              <ng-container
                                *ngFor="
                                  let sheet of Sheets.controls;
                                  let i = index
                                "
                              >
                                <tr>
                                  <ng-container [formGroupName]="i">
                                    <td>
                                      {{
                                        excelSheetForm.value.sheets[i][
                                          "sheet_name"
                                        ]
                                      }}
                                      <!-- <input  class="input hidden" type="text" formControlName="sheet_name" name="sheet_name"
                                                placeholder="Sheet Name" readonly required /> -->
                                    </td>
                                    <td
                                      [ngClass]="{
                                        invalid:
                                          sheet.get('question_column')
                                            ?.invalid && submitted,
                                      }"
                                    >
                                      <input
                                        type="text"
                                        class="input"
                                        formControlName="question_column"
                                        required
                                      />
                                    </td>
                                    <td
                                      [ngClass]="{
                                        invalid:
                                          sheet.get('answer_column')?.invalid &&
                                          submitted,
                                      }"
                                    >
                                      <input
                                        type="text"
                                        class="input"
                                        formControlName="answer_column"
                                        required
                                      />
                                    </td>
                                    <!-- <td   [ngClass]="{'invalid':sheet.get('starting_row')?.invalid && submitted}">
                                                <input type="number" class="input"  formControlName="starting_row" min="1" required>
                                                </td> -->
                                    <td>
                                      <input
                                        type="text"
                                        class="input"
                                        formControlName="comments_column"
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="text"
                                        class="input"
                                        formControlName="attachment_column"
                                      />
                                    </td>

                                    <td>
                                      <div class="field remove-btn-wrapper">
                                        <button
                                          type="button"
                                          class="button is-danger is-light remove-btn"
                                          (click)="removeSheet(i)"
                                          title="Remove Sheet"
                                        >
                                          <i class="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </ng-container>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-center mt-3"
                    *ngIf="progressLoader"
                  >
                    <span class="progress-txt-loader"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="position-relative">
          <div class="flex py-6 step-panel-footer">
            <button class="btn btn-primary" (click)="TrainRfp()">
              Train AI
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Doc Summay form modal window -->
<div
  class="modal fade docSummaryModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  id="companyDetails"
  #topicModal
>
  <div
    class="modal-dialog modal-dialog-scrollable modal-lg"
    [ngClass]="{ 'full-screen': metricFullscreen }"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Summary</h4>
        <span>
          <i
            class="fa metricFullscreen"
            [ngClass]="{
              'fa-down-left-and-up-right-to-center': metricFullscreen,
              'fa-up-right-and-down-left-from-center': !metricFullscreen,
            }"
            (click)="metricFullscreen = !metricFullscreen"
          ></i
          >&nbsp;&nbsp;
          <i
            class="fa-solid fa-xmark exitIcon"
            #closebutton
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="exitIconReset()"
          ></i>
        </span>
      </div>
      <div>
        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <div class="position-relative">
        <div class="d-flex tablist">
          <div
            class="col"
            [class.active]="tabContent == 'summary'"
            (click)="showTab('summary')"
          >
            Summary
          </div>
          <div
            class="col"
            [class.active]="tabContent == 'detailed_summary'"
            (click)="showTab('detailed_summary')"
          >
            Detailed Summary
          </div>
          <div
            class="col"
            [class.active]="tabContent == 'metadata_details'"
            (click)="showTab('metadata_details')"
          >
            Meta Data
          </div>
          <div
            class="col"
            [class.active]="tabContent == 'rates_and_services'"
            (click)="showTab('rates_and_services')"
          >
            Rate and Services
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="position-relative">
          <div class="col" *ngIf="tabContent == 'summary'">
            <p [innerHTML]="docSummary['summary']"></p>
          </div>
          <div class="col" *ngIf="tabContent == 'detailed_summary'">
            <p [innerHTML]="docSummary['detailed_summary']"></p>
          </div>
          <div class="col" *ngIf="tabContent == 'metadata_details'">
            <p [innerHTML]="docSummary['metadata_details']"></p>
          </div>
          <div class="col" *ngIf="tabContent == 'rates_and_services'">
            <p [innerHTML]="docSummary['rates_and_services']"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Delete Modal Window -->
<div
  class="modal fade deleteModal"
  id="deleteModal"
  tabindex="-1"
  aria-labelledby="deleteModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="deleteModalLabel">Delete Category</h4>
        <i
          class="fa-solid fa-xmark exitIcon"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></i>
      </div>
      <div class="modal-body">Are you sure you want to delete?</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          No
        </button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="deleteRFP(selectedRfp)"
          data-bs-dismiss="modal"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>

<!--Doc Summay form modal window -->
<div
  class="modal fade docPreviewModal"
  data-bs-keyboard="false"
  id="docPreview"
  #topicModal
>
  <div
    class="modal-dialog modal-dialog-scrollable modal-lg"
    [ngClass]="{ 'full-screen': metricFullscreen }"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Preview</h4>
        <span>
          <i
            class="fa metricFullscreen"
            [ngClass]="{
              'fa-down-left-and-up-right-to-center': metricFullscreen,
              'fa-up-right-and-down-left-from-center': !metricFullscreen,
            }"
            (click)="metricFullscreen = !metricFullscreen"
          ></i
          >&nbsp;&nbsp;
          <i
            class="fa-solid fa-xmark exitIcon"
            #closebutton
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="exitIconReset()"
          ></i>
        </span>
      </div>

      <div class="modal-body">
        <div class="col">
          <div *ngIf="spinner">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
          </div>
          <ng-container *ngIf="!spinner">
            @if (previewFileType == "xls" || previewFileType == "xlsx") {
              <div class="table-responsive">
                <div class="tblCrd">
                  <ngx-excel-viewer
                    [data]="dataExcel"
                    [editable]="isEditing"
                    id="Source"
                    saveDataOutput="edited-only"
                    (onDataSave)="onSave($event)"
                    [sheetNames]="sheetNames"
                    [documentDetails]="document_details"
                    [sheetDetail]="sheetDetail"
                    [events]="eventEmitter"
                    (onScrollEnd)="onScrollExcel($event)"
                  ></ngx-excel-viewer>
                </div>
              </div>
            } @else {
              <ng-container *ngIf="!spinner">
                <pdf-viewer
                  [src]="urlSafe"
                  [render-text]="true"
                  [original-size]="false"
                  style="width: 100%; height: 100vh"
                ></pdf-viewer>
              </ng-container>
            }
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<app-dialog-modal
  [isVisible]="isModalVisible"
  [popLoader]="popLoader"
  [size]="metricFullscreen ? 'full-screen' : 'large'"
>
  <div modal-header class="modal-header">
    <ng-container *ngIf="seletedModal == 'category'">
      <h4 class="modal-title">{{ selectedCompanyDetails?.company_name }}</h4>
    </ng-container>
    <ng-container *ngIf="seletedModal == 'trainai'">
      <h4 class="modal-title">AI Training</h4>
    </ng-container>

    <span>
      <i
        class="fa metricFullscreen"
        [ngClass]="{
          'fa-down-left-and-up-right-to-center': metricFullscreen,
          'fa-up-right-and-down-left-from-center': !metricFullscreen,
        }"
        (click)="metricFullscreen = !metricFullscreen"
      ></i
      >&nbsp;&nbsp;
      <i
        class="fa-solid fa-xmark exitIcon"
        #closebutton
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="onModelClose()"
      ></i>
    </span>
  </div>
  <div modal-body class="modal-body">
    <ng-container *ngIf="seletedModal == 'category'">
      <div class="col">
        <form
          class="rfpconfigFrom"
          [formGroup]="rfpconfigFrom"
          autocomplete="off"
        >
          <div class="row">
            <div class="col-5">
              <label for="topic" class="form-label mandatoryLabel"
                >Folder Name <i class="fa-solid fa-asterisk mandatoryIcon"></i
              ></label>
            </div>
            <div class="col-7">
              <input
                type="text"
                class="form-control"
                TrimText
                formControlName="type_name"
                id="type_name"
                name="type_name"
                placeholder="Enter Your Folder Name"
                autocomplete="off"
              />
              <span
                class="text-danger"
                *ngIf="
                  submitted && rfpconfigFrom.hasError('required', 'type_name')
                "
                >Name is required.
              </span>
              <span
                class="text-danger"
                *ngIf="
                  submitted &&
                  rfpconfigFrom.controls['type_name'].hasError('pattern')
                "
              >
                Invalid input: Only special characters (space, &, -) are
                allowed.
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <label for="topic" class="form-label mandatoryLabel"
                >Description <i class="fa-solid fa-asterisk mandatoryIcon"></i
              ></label>
            </div>
            <div class="col-7">
              <textarea
                class="form-control"
                TrimText
                placeholder="Enter Your Description"
                formControlName="description"
              ></textarea>
              <span
                class="text-danger"
                *ngIf="
                  submitted && rfpconfigFrom.hasError('required', 'description')
                "
                >description is required.
              </span>
              <span
                class="text-danger"
                *ngIf="
                  submitted &&
                  rfpconfigFrom.controls['description'].hasError('pattern')
                "
                >Enter valid description
              </span>
            </div>
          </div>
          <div class="row" style="display: none">
            <div class="col-5">
              <label class="form-label mandatoryLabel">Active </label>
            </div>
            <div class="col-7">
              <div class="form-check form-switch">
                <label class="form-check-label" for="active"></label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  formControlName="is_active"
                  name="is_active"
                  id="active"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </ng-container>
    <ng-container *ngIf="seletedModal == 'trainai'">
      <div class="col">
        <div class="stepper-wrapper">
          <div class="stepper-items">
            <ul></ul>
          </div>
          <div class="stepper-panels">
            <div class="step-pannel-content">
              <div class="step-pannel-body">
                <form [formGroup]="uploadFileForm">
                  <!-- <div class="d-flex justify-content-center flex-row mt-2">
                            <div class="col-2">Title <i class="fa-solid fa-asterisk mandatoryIcon"></i></div>
                            <div class="col-4">
                                <input type="text" name="title" formControlName="title" placeholder="Enter title" />
                                <span class="text-danger"  *ngIf="submitted && uploadFileForm.hasError('required','title')">
                                  Title required
                                </span>
                                <span class="text-danger"
                    *ngIf="submitted && uploadFileForm.controls['title'].hasError('pattern')">
                    Invalid input: Only special characters (space, &, -) are allowed.
                    </span>
                            </div>
                            </div>  -->
                  <div
                    class="d-flex justify-center align-center flex-column mt-3"
                  >
                    <!-- <span class="d-flex justify-content-center align-items-center">
                                @if(uploadSelectFile.length==0){
                                 <label for="customFileUpload" class="custom-upload-button">
                                    <span>Upload File</span>
                                    <input type="file"  #excelFile accept=".txt,.doc,.docx,.xls,.xlsx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" id="customFileUpload" style="display: none;" (change)="chooseUploadFile($event)">
                                </label>
                                }

                                <span>{{uploadSelectFile[0]?.name}}</span>
                                 
                                 
                            </span> -->
                    <div
                      class="drop-zone"
                      (dragover)="
                        !progressLoader && !editTrainId && onDragOver($event)
                      "
                      (dragleave)="
                        !progressLoader && !editTrainId && onDragLeave($event)
                      "
                      (drop)="!progressLoader && !editTrainId && onDrop($event)"
                      [ngClass]="{
                        'drag-over': isDragOver,
                        'upload-disabled': progressLoader,
                        'reupload-mode': editTrainId,
                      }"
                    >
                      <!-- Add a re-upload hint inside the drop zone, after the drop-hint paragraph -->
                      <p class="drop-hint" *ngIf="editTrainId">
                        Re-upload: select one file to replace the existing
                        document.
                      </p>
                      <i class="bi bi-cloud-arrow-up drop-icon"></i>
                      <p class="drop-text">Drag & drop files here, or Select</p>

                      <div class="d-flex justify-content-center gap-3 mb-3">
                        <button
                          type="button"
                          class="btn-file-type"
                          [class.active]="
                            uploadFiletype === 'pdf' || uploadFiletype === 'doc'
                          "
                          [disabled]="progressLoader"
                          (click)="!progressLoader && triggerFileInput('doc')"
                        >
                          <div class="d-flex align-items-center gap-1">
                            <img
                              src="../../../../../assets/images/file_types/pdf.png"
                            />
                            <img
                              src="../../../../../assets/images/file_types/docx.png"
                            />
                          </div>
                          <small>PDF / DOC</small>
                        </button>
                        <button
                          type="button"
                          class="btn-file-type"
                          [class.active]="uploadFiletype === 'xls'"
                          [disabled]="progressLoader"
                          (click)="!progressLoader && triggerFileInput('xls')"
                        >
                          <img
                            src="../../../../../assets/images/file_types/excel-file.png"
                          />
                          <small>Excel</small>
                        </button>
                      </div>

                      <input
                        type="file"
                        #docFileInput
                        accept=".txt,.doc,.docx,.pdf"
                        style="display: none"
                        [attr.multiple]="editTrainId ? null : true"
                        (change)="onDocFileChange($event)"
                      />
                      <input
                        type="file"
                        #xlsFileInput
                        accept=".xls,.xlsx,.xlsm"
                        style="display: none"
                        [attr.multiple]="editTrainId ? null : true"
                        (change)="onXlsFileChange($event)"
                      />

                      <p class="drop-hint">
                        Supported: PDF, DOC, DOCX, XLS, XLSX
                      </p>
                    </div>

                    <!-- SINGLE chips block — keep only this one -->
                    <div
                      class="selected-files-list"
                      *ngIf="uploadSelectFile.length > 0"
                    >
                      <div
                        class="file-chip"
                        *ngFor="let file of uploadSelectFile; let i = index"
                      >
                        <i class="bi bi-file-earmark"></i>
                        <span class="file-chip-name">{{ file.name }}</span>
                        <i
                          class="bi bi-x-circle file-chip-remove"
                          [class.chip-remove-disabled]="progressLoader"
                          (click)="!progressLoader && removeSelectedFile(i)"
                        ></i>
                      </div>
                    </div>

                    <div class="d-flex justify-content-center flex-row mt-2">
                      <div class="col-2"></div>
                      <div class="col-4">
                        <span
                          class="text-danger"
                          *ngIf="submitted && uploadSelectFile.length == 0"
                        >
                          File Required
                        </span>
                      </div>
                    </div>
                  </div>
                </form>

                <div class="sheet-form-list" *ngIf="showsheetform">
                  <div class="sheet-form-container">
                    <form [formGroup]="excelSheetForm">
                      <div formArrayName="sheets" class="sheet-list">
                        <table class="table table-responsive">
                          <thead>
                            <th>File</th>
                            <th>Sheet Name</th>
                            <th>Question Column</th>
                            <th>Answer Column</th>

                            <th>Comments Column</th>
                            <th>Attachments column</th>
                          </thead>
                          <tbody>
                            <ng-container
                              *ngFor="
                                let sheet of Sheets.controls;
                                let i = index
                              "
                            >
                              <tr>
                                <ng-container [formGroupName]="i">
                                  <td>
                                    <span class="file-name-badge">
                                      {{
                                        excelSheetForm.value.sheets[i][
                                          "file_name"
                                        ]
                                      }}
                                    </span>
                                  </td>
                                  <td>
                                    {{
                                      excelSheetForm.value.sheets[i][
                                        "sheet_name"
                                      ]
                                    }}
                                  </td>
                                  <td
                                    [ngClass]="{
                                      invalid:
                                        sheet.get('question_column')?.invalid &&
                                        submitted,
                                    }"
                                  >
                                    <input
                                      type="text"
                                      class="input"
                                      formControlName="question_column"
                                      required
                                    />
                                  </td>
                                  <td
                                    [ngClass]="{
                                      invalid:
                                        sheet.get('answer_column')?.invalid &&
                                        submitted,
                                    }"
                                  >
                                    <input
                                      type="text"
                                      class="input"
                                      formControlName="answer_column"
                                      required
                                    />
                                  </td>

                                  <td>
                                    <input
                                      type="text"
                                      class="input"
                                      formControlName="comments_column"
                                    />
                                  </td>

                                  <td>
                                    <input
                                      type="text"
                                      class="input"
                                      formControlName="attachment_column"
                                    />
                                  </td>

                                  <td>
                                    <div class="field remove-btn-wrapper">
                                      <button
                                        type="button"
                                        class="button is-danger is-light remove-btn"
                                        (click)="removeSheet(i)"
                                        title="Remove Sheet"
                                      >
                                        <i class="bi bi-trash"></i>
                                      </button>
                                    </div>
                                  </td>
                                </ng-container>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div modal-footer class="modal-footer">
    <ng-container *ngIf="seletedModal == 'category'">
      <div class="form-group topicBtnGroup">
        <ng-container>
          <button
            class="btn btn-info cancelBtn"
            type="button"
            (click)="exitIconReset()"
          >
            Cancel
          </button>
          <button
            *ngIf="!showUpdateButton"
            class="btn btn-primary updateBtn"
            type="button"
            (click)="saveRfp()"
          >
            Save
          </button>
          <button
            *ngIf="showUpdateButton"
            class="btn btn-primary updateBtn"
            type="button"
            (click)="updateRFP()"
          >
            Update
          </button>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="seletedModal == 'trainai'">
      <div class="form-group topicBtnGroup">
        <div class="flex py-6 step-panel-footer">
          <button
            [disabled]="progressLoader"
            class="btn btn-primary updateBtn"
            type="button"
            (click)="TrainRfp()"
          >
            Train AI
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</app-dialog-modal>

<app-dialog-modal
  [isVisible]="isFileGenModalVisible"
  [popLoader]="popLoader"
  [size]="''"
>
  <div modal-header class="modal-header">
    <ng-container>
      <h4 class="modal-title">Generate Document</h4>
    </ng-container>

    <span>
      <i
        class="fa-solid fa-xmark exitIcon"
        #closebutton
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="isFileGenModalVisible = false"
      ></i>
    </span>
  </div>
  <div modal-body class="modal-body">
    <ng-container>
      <div class="col">
        <ng-container *ngIf="genFiletyleList['filetype'].length > 0">
          <ng-container
            *ngFor="let list of genFiletyleList['filetype']; let i = index"
          >
            <div class="check-list" (change)="selectFileType(list?.type)">
              <label
                ><input type="radio" name="native" value="{{ list['type'] }}" />
                {{ list["label"] }}</label
              >
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div modal-footer class="modal-footer">
    <ng-container>
      <div class="form-group topicBtnGroup">
        <ng-container>
          <button
            class="btn btn-info cancelBtn"
            type="button"
            (click)="isFileGenModalVisible = false"
          >
            Cancel
          </button>
          <button
            class="btn btn-primary updateBtn"
            [disabled]="botQAgenFile == null"
            type="button"
            (click)="genFileTypeSubmit()"
          >
            Save
          </button>
        </ng-container>
      </div>
    </ng-container>
  </div>
</app-dialog-modal>
